import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import styles from './TransactionsSkeleton.module.css';

/** Primeira carga da aba Transações: o desenho da página, sem dados. */
function TransactionsSkeleton() {
    return (
        <div className={styles.page} aria-busy="true" aria-label="Carregando transações">
            <div className={styles.header}>
                <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: '12px' }} />
                <div className={styles.headerTexts}>
                    <Skeleton variant="text" width={160} height={28} />
                    <Skeleton variant="text" width={260} />
                </div>
            </div>
            <div className={styles.kpis}>
                {[0, 1, 2].map(key => (
                    <Skeleton key={key} variant="rounded" height={82} sx={{ borderRadius: '18px' }} />
                ))}
            </div>
            <div className={styles.columns}>
                <div className={styles.main}>
                    <Skeleton variant="rounded" height={150} sx={{ borderRadius: '18px' }} />
                    <Skeleton variant="rounded" height={300} sx={{ borderRadius: '18px' }} />
                </div>
                <Skeleton variant="rounded" height={240} sx={{ borderRadius: '18px' }} />
            </div>
        </div>
    );
}

export default TransactionsSkeleton;
